module.exports = __webpack_public_path__ + "static/media/BookingsIcon.46c2961a.svg";